import React from "react";

function SettingsGroups() {
	return <div>SettingsGroups</div>;
}

export default SettingsGroups;
